import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const popup = css`
  position: relative;
  width: 410px;
  display: flex;
  pointer-events: all;
  flex-direction: column;
`;

export const popupArrow = css`
  :before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
    border-top: 11px solid ${colors.gray.light};
    border-right: 11px solid transparent;
    border-left: 11px solid transparent;
  }

  :after {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
    border-top: 10px solid ${colors.white};
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
  }
`;

export const header = css`
  display: flex;
  align-items: center;
  min-height: 25px;
`;

export const titleWrapper = css`
  display: flex;
  flex-direction: column;
  padding: 17px 20px;
  background: ${colors.gray.lightest};
`;

export const body = css`
  padding: 20px 20px 0px;

  & > span:not(:first-child) {
    display: block;
    margin-top: 10px;
  }
`;

export const infoLabel = css`
  margin-right: 3px;
`;

export const addressPlaceholder = css`
  vertical-align: middle;
`;

export const deviceStatusIcon = css`
  height: 24px;
  width: 24px;
  margin-right: 10px;
  padding: 4px;
  box-sizing: border-box;
  border-radius: 50%;
`;

export const unpluggedIcon = css`
  ${deviceStatusIcon}
  background-color: ${colors.custom.warning15};
  color: ${colors.warning.default};
`;

export const pluggedIcon = css`
  ${deviceStatusIcon}
  background-color: ${colors.shadows.getShadow(colors.success.hover, 0.15)};
`;

export const divider = css`
  && {
    margin-top: 10px;
  }
`;

const bannerIcon = css`
  width: 14px;
  height: 14px;
  margin-right: 10px;
  overflow: initial;
`;

const banner = css`
  display: flex;
  align-items: center;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 5px;
  border-radius: 5px;
`;

export const pluggedBanner = css`
  background-color: ${colors.shadows.getShadow(colors.primary.default, 0.05)};
  ${banner}

  > svg {
    ${bannerIcon}
    color: ${colors.gray.default};
  }
`;

export const unpluggedBanner = css`
  background-color: ${colors.shadows.getShadow(colors.warning.default, 0.08)};
  ${banner}

  > svg {
    ${bannerIcon}
    color: ${colors.warning.default};
  }
`;

export const tagContainer = css`
  padding-left: 14px;
`;

export const tag = css`
  background-color: ${colors.shadows.getShadow(colors.warning.default, 0.1)};

  > span {
    font-weight: ${fonts.weight.medium};
    font-size: ${fonts.size.smallest};
    color: ${colors.gray.dark};
  }
`;

export const warningIcon = css`
  color: ${colors.warning.default};
  padding-right: 12px;
  width: 25px;
`;

export const warningMessage = css`
  display: flex;
`;
